import { Button, Grid } from "@arco-design/web-react";
import { IconPlus } from "@arco-design/web-react/icon";
import React from "react";


import { useNavigate } from "react-router-dom";
import FormVariantCard from "./FormVariantCard";
import CardGrid from "./CardGrid";
import ABReadout from "./ABReadout";

const { Row, Col } = Grid;


export default function FormEditor({ campaignId, formVariants, onChanged }) {
    let history = useNavigate();

    return (
        <>
            <ABReadout formVariants={formVariants || []} />
            <Row>
                <Col span={24}>
                    <Button type="primary" onClick={() => history(`/signups/` + campaignId + `/form/new`)}
                        icon={<IconPlus />}>
                        Add A Form
                    </Button>
                </Col>
                <Col span={24} style={{ marginTop: 16 }}>
                    <CardGrid data-fix-field="forms">
                        {
                            formVariants && formVariants.map((item) => (
                                <div key={item.id} data-fix-field={`form-variant-${item.id}`}>
                                    <FormVariantCard item={item} campaignId={campaignId} onChanged={onChanged} />
                                </div>
                            ))
                        }
                    </CardGrid>
                </Col>
            </Row>
        </>
    );
}
